exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mix__chart h3[data-v-29dc0f48]{font-weight:600;font-size:1.42857em}.chart__wrapper[data-v-29dc0f48]{padding:15px 0px 15px 15px}.chart__wrapper h3[data-v-29dc0f48]{font-family:Lora,serif;color:#3E5473;font-size:1.14286em;margin-bottom:18px}\n", ""]);

